// extracted by mini-css-extract-plugin
export default {"userInitialButton":"UserInitial_userInitialButton__EmtdF","userInitial":"UserInitial_userInitial__QQTWH"};